import { render } from "./UiToast.vue?vue&type=template&id=05357492"
import script from "./UiToast.vue?vue&type=script&lang=js"
export * from "./UiToast.vue?vue&type=script&lang=js"

import "./UiToast.vue?vue&type=style&index=0&id=05357492&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__